import Vue from 'vue'
import VueRouter from 'vue-router'
import FilesView from '../views/FilesView.vue'
import { authGuard } from '@/auth/authGuard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Current',
    component: FilesView,
    meta: {
      title: 'Files',
      requiresAuth: true
    }
  },
  {
    path: '/doc',
    name: 'Edit',
    component: () => import(/* webpackChunkName: "upload" */ '../views/upload.vue'),
    props: route => ({ id: route.query.id }),
    meta: {
      title: 'Edit Files',
      requiresAuth: true,
      requiresWriteAccess: true
    }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: () => import(/* webpackChunkName: "upload" */ '../views/upload.vue'),
    meta: {
      title: 'Upload Files',
      requiresAuth: true,
      requiresWriteAccess: true
    }
  },
  {
    path: '/retail-manager',
    name: 'Retail Ad Manager',
    component: () => import('@/views/RetailAdManager.vue'),
    meta: {
      title: 'Retail Ad Manager',
      requiresAuth: true
    }
  },
  {
    path: '/retail-items/:store_id/:ad_id/:meat_grid',
    name: 'RetailAdItems',
    component: () => import('@/views/RetailAdItems.vue'),
    meta: {
      title: 'Retail Ad Items',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/ad-planner-edit',
    name: 'AdPlannerEdit',
    component: () => import('@/views/AdPlannerEdit.vue'),
    meta: {
      title: 'Ad Planner Edit',
      requiresAuth: true
    }
  },
  {
    path: '/ad-planner-items/:store_id/:ad_id/:meat_grid',
    name: 'AdPlannerEditItems',
    component: () => import('@/views/AdPlannerEditItems.vue'),
    meta: {
      title: 'Ad Planner Items',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import(/* webpackChunkName: "notifications" */ '@/views/Notifications.vue'),
    meta: {
      title: 'Notifications',
      requiresAuth: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve(async (to, from, next) => {
  to.meta.referrer = from.name
  if (to.meta) {
    // Use the route's "meta.title" value to assign the page's title
    if (to.meta.title) document.title = to.meta.title
    // For routes requiring authentication ( has "meta.requiresAuth" property )
    if (to.meta.requiresAuth === true) {
      return authGuard(to, from, next)
    }
    return next()
  } else {
    return next()
  }
})

export default router
